import { useMemo } from 'react';

import { IconTextLong } from '@components/icons/text-long';
import { FilterConfigField } from '@components/table';

import { useStore } from 'models/Provider';

export const useMessageTextFilter = (): FilterConfigField => {
  const { t } = useStore();

  return useMemo(
    () => ({
      id: 'texts',
      label: t('messages.filters.text.title'),
      icon: <IconTextLong />,
      type: 'paragraph',
      allowedComparers: ['contains'],
      toExternalQuery: (filter) => {
        return { message__icontains: String(filter.value) };
      },
    }),
    [t],
  );
};
